import AccreditationForm from './AccreditationForm'

export default AccreditationForm
